import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Address_Interface } from 'src/app/Interface/Address_Interface';
import { Customer_Interface } from 'src/app/Interface/Customer_Interface';
import { Customer_List_Interface } from 'src/app/Interface/Customer_List_Interface';
import { DeviceBehfa_Interface } from 'src/app/Interface/DeviceBehfa_Interface';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { LetterRequestCustomer_Activity } from 'src/app/Interface/LetterRequestCustomer_Activity';
import { LetterRequestCustomer_Cancel } from 'src/app/Interface/LetterRequestCustomer_Cancel';
import { LetterRequestCustomer_Device_Interface } from 'src/app/Interface/LetterRequestCustomer_Device_Interface';
import { LetterRequestCustomer_History_Interface } from 'src/app/Interface/LetterRequestCustomer_History_Interface';
import { LetterRequestCustomer_List_Interface } from 'src/app/Interface/LetterRequestCustomer_List_Interface';
import { LetterRequestCustomer_Order_Interface } from 'src/app/Interface/LetterRequestCustomer_Order_Interface';
import { LetterRequestCustomer_ScheduleTable_Interface } from 'src/app/Interface/LetterRequestCustomer_ScheduleTable_Interface';
import { LetterRequestCustomer_Schedule_BehfaDevice_Interface } from 'src/app/Interface/LetterRequestCustomer_Schedule_BehfaDevice_Interface';
import { LetterRequestCustomer_Schedule_Interface } from 'src/app/Interface/LetterRequestCustomer_Schedule_Interface';
import { Letter_Interface } from 'src/app/Interface/Letter_Interface';
import { Nav_Interface } from 'src/app/Interface/Nav_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LetterRequestCustomerService {

  constructor(private http: HttpClient) { }

  GetLetterRequestCustomer(
    StartDate: String,
    EndDate: String,
    Customer_Id: number,
    LetterTypeId: number,
    SubjectId: number,
    SubmitPeriodDate: number,
    DeviceName: String,
    LetterNumber: String): Observable<Array<LetterRequestCustomer_List_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/GetLetterRequestCustomer?StartDate=" + StartDate
      + "&EndDate=" + EndDate
      + "&Customer_Id=" + Customer_Id
      + "&LetterTypeId=" + LetterTypeId
      + "&SubjectId=" + SubjectId
      + "&DeviceName=" + DeviceName
      + "&SubmitPeriodDate=" + SubmitPeriodDate
      + "&LetterNumber=" + LetterNumber
    ).pipe(
      map(data => {
        return data as Array<LetterRequestCustomer_List_Interface>
      })
    )
  }

  GetLetterRequestCustomerCustomerInbox(): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/GetLetterRequestCustomerCustomerInbox").pipe(
      map(data => {
        return data as any
      })
    )
  }

  SetLetterRequestCustomerExpertsVisible(id:number): Observable<Array<LetterRequestCustomer_List_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/SetLetterRequestCustomerExpertsVisible?id=" + id).pipe(
      map(data => {
        return data as Array<LetterRequestCustomer_List_Interface>
      })
    )
  }

  GetLetterRequestCustomerCustomer(
    StartDate: String,
    EndDate: String,
    CustomerName: String,
    LetterTypeId: number,
    SubjectId: number,
    DeviceName: String,
    SubmitPeriodDate: number,
    LetterNumber: String): Observable<Array<Customer_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/GetLetterRequestCustomerCustomer?StartDate=" + StartDate
      + "&EndDate=" + EndDate
      + "&LetterTypeId=" + LetterTypeId
      + "&SubjectId=" + SubjectId
      + "&DeviceName=" + DeviceName
      + "&CustomerName=" + CustomerName
      + "&SubmitPeriodDate=" + SubmitPeriodDate
      + "&LetterNumber=" + LetterNumber
    ).pipe(
      map(data => {
        return data as Array<Customer_Interface>
      })
    )
  }


  GetLetterRequestCustomerCalibration(
    StartDate: String,
    EndDate: String): Observable<Array<LetterRequestCustomer_List_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/GetLetterRequestCustomerCalibration?StartDate=" + StartDate
      + "&EndDate=" + EndDate).pipe(
        map(data => {
          return data as Array<LetterRequestCustomer_List_Interface>
        })
      )
  }

  GetActiveMission(): Observable<Array<General_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/GetActiveMission").pipe(
        map(data => {
          return data as Array<General_Interface>
        })
      )
  }

  GetActiveMissionByLetter(id:number,type:number): Observable<Array<LetterRequestCustomer_Cancel>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/GetActiveMissionByLetter?id=" + id+ "&type=" + type).pipe(
        map(data => {
          return data as Array<LetterRequestCustomer_Cancel>
        })
      )
  }


  GetActiveMissionByLetterCancelUser(id:number,type:number): Observable<Array<LetterRequestCustomer_Cancel>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/GetActiveMissionByLetterCancelUser?id=" + id+ "&type=" + type).pipe(
        map(data => {
          return data as Array<LetterRequestCustomer_Cancel>
        })
      )
  }

  GetActiveMissionDeviceBehfa(id:number, withDelete:number): Observable<Array<DeviceBehfa_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/GetActiveMissionDeviceBehfa?id=" + id
      + "&withDelete=" + withDelete).pipe(
        map(data => {
          return data as Array<DeviceBehfa_Interface>
        })
      )
  }

  PostActiveMissionDeviceBehfaAdd(device_id:number,schedule_id:number,Dsc: String): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/PostActiveMissionDeviceBehfaAdd?device_id=" + device_id
      + "&schedule_id=" + schedule_id
      + "&Dsc=" + Dsc).pipe(
        map(data => {
          return data as any
        })
      )
  }

  PostActiveMissionDeviceBehfaRemove(id:number,Dsc: String): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/PostActiveMissionDeviceBehfaRemove?id=" + id
      + "&Dsc=" + Dsc).pipe(
        map(data => {
          return data as any
        })
      )
  }

  GetLetterRequestCustomerDeviceList(
    StartDate: String,
    EndDate: String): Observable<Array<LetterRequestCustomer_List_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/GetLetterRequestCustomerDeviceList?StartDate=" + StartDate
      + "&EndDate=" + EndDate).pipe(
        map(data => {
          return data as Array<LetterRequestCustomer_List_Interface>
        })
      )
  }

  GetLetterRequestCustomerDeviceListDetail(
    id: number,
    scheduleId: number,
    ForCalibration: number): Observable<Array<LetterRequestCustomer_Device_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/GetLetterRequestCustomerDeviceListDetail?id=" + id
      + "&scheduleId=" + scheduleId
      + "&ForCalibration=" + ForCalibration).pipe(
        map(data => {
          return data as Array<LetterRequestCustomer_Device_Interface>
        })
      )
  }

  GetLetterRequestCustomerPreOrder(
    StartDate: String,
    EndDate: String): Observable<Array<LetterRequestCustomer_List_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/GetLetterRequestCustomerPreOrder?StartDate=" + StartDate
      + "&EndDate=" + EndDate).pipe(
        map(data => {
          return data as Array<LetterRequestCustomer_List_Interface>
        })
      )
  }

  GetLetterRequestCustomerSadereh(
    StartDate: String,
    EndDate: String): Observable<Array<LetterRequestCustomer_List_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/GetLetterRequestCustomerSadereh?StartDate=" + StartDate
      + "&EndDate=" + EndDate).pipe(
        map(data => {
          return data as Array<LetterRequestCustomer_List_Interface>
        })
      )
  }

  GetLetterRequestCustomerScheduleCustomer(
    StartDate: String,
    EndDate: String): Observable<Array<LetterRequestCustomer_List_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/GetLetterRequestCustomerScheduleCustomer?StartDate=" + StartDate
      + "&EndDate=" + EndDate).pipe(
        map(data => {
          return data as Array<LetterRequestCustomer_List_Interface>
        })
      )
  }

  GetLetterRequestCustomerCalibration_INLocation(draft: boolean): Observable<Array<LetterRequestCustomer_List_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/GetLetterRequestCustomerCalibration_INLocation?draft=" + draft).pipe(
        map(data => {
          return data as Array<LetterRequestCustomer_List_Interface>
        })
      )
  }

  GetLetterRequestCustomerCalibration_Reception(InLocation: boolean, draft: boolean): Observable<Array<LetterRequestCustomer_List_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/GetLetterRequestCustomerCalibration_Reception?draft=" + draft
      + "&InLocation=" + InLocation).pipe(
        map(data => {
          return data as Array<LetterRequestCustomer_List_Interface>
        })
      )
  }

  GetLetterRequestCustomerCalibrationRecipt(LetterId: number, InLocation: boolean): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/GetLetterRequestCustomerCalibrationRecipt?LetterId=" + LetterId
      + "&InLocation=" + InLocation).pipe(
        map(data => {
          return data as any
        })
      )
  }

  GetLetterRequestCustomerPeyvaset(singleRecordSelection: number,
    searchletterid: number,
    customername: String): Observable<Array<LetterRequestCustomer_List_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/GetLetterRequestCustomerPeyvaset?searchletterid=" + searchletterid
      + "&customername=" + customername
      + "&singleRecordSelection=" + singleRecordSelection).pipe(
        map(data => {
          return data as Array<LetterRequestCustomer_List_Interface>
        })
      )
  }

  GetLetterRequestCustomerSchduleForm(persianDate: String): Observable<Array<LetterRequestCustomer_List_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/GetLetterRequestCustomerSchduleForm?persianDate=" + persianDate).pipe(
        map(data => {
          return data as Array<LetterRequestCustomer_List_Interface>
        })
      )
  }

  GetOperation(
    id: number,
    draftId: number,
    Draft: boolean,
    PreOrder: boolean,
    customerRequest: boolean,): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/GetOperation?id=" + id
      + "&draftId=" + draftId
      + "&Draft=" + Draft
      + "&customerRequest=" + customerRequest
      + "&PreOrder=" + PreOrder).pipe(
        map(data => {
          return data as any
        })
      )
  }

  GetLetterRequestCustomerSchedule(
    StartDate: String,
    EndDate: String,
    CustomerName: String,
    CalibrationExpert: String,
    showUnSchedule: boolean,
    ExpertCalibration_Type: number,): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/GetLetterRequestCustomerSchedule?CustomerName=" + CustomerName
      + "&showUnSchedule=" + showUnSchedule
      + "&ExpertCalibration_Type=" + ExpertCalibration_Type
      + "&CalibrationExpert=" + CalibrationExpert
      + "&EndDate=" + EndDate
      + "&StartDate=" + StartDate).pipe(
        map(data => {
          return data as any
        })
      )
  }

  GetSingle(id: Number, DeviceLocationFilter: Number=-1): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Letterrequestcustomer/GetSingle?id=" + id
      + "&DeviceLocationFilter=" + DeviceLocationFilter).pipe(
      map(data => {
        return data as any
      })
    )
  }

  GetCopy(id: Number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Letterrequestcustomer/GetCopy?id=" + id).pipe(
      map(data => {
        return data as any
      })
    )
  }

  GetSingleDevice(id: Number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Letterrequestcustomer/GetSingleDevice?id=" + id).pipe(
      map(data => {
        return data as any
      })
    )
  }

  ChangeDraftClibrationReception(id: Number,Dsc: String,InLocation:boolean): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Letterrequestcustomer/ChangeDraftClibrationReception?id=" + id
    + "&InLocation=" + InLocation
    + "&Dsc=" + Dsc).pipe(
      map(data => {
        return data as any
      })
    )
  }

  GetUserrole(
    OrderId: number,
    id: String,): Observable<Array<General_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/GetUserrole?id=" + id
      + "&OrderId=" + OrderId).pipe(
        map(data => {
          return data as Array<General_Interface>
        })
      )
  }

  PostCancelMission(
    id: number,
    dsc: String,): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/PostCancelMission?id=" + id
      + "&dsc=" + dsc).pipe(
        map(data => {
          return data as any
        })
      )
  }

  PostCancelMissionUser(
    id: number,
    dsc: String,): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/PostCancelMissionUser?id=" + id
      + "&dsc=" + dsc).pipe(
        map(data => {
          return data as any
        })
      )
  }


  AddEditLetterRequestCustomer(model: Letter_Interface,
    bazgashtBeNamehTarikh: string,
    customer: Customer_List_Interface,
    customerAddress: Address_Interface,
    Device: Array<LetterRequestCustomer_Device_Interface>,
    Schedule: Array<LetterRequestCustomer_Schedule_Interface>,
    MailMessage: Array<General_Interface>,
    MailMessage_Schedule: Array<General_Interface>,
    Dsc: Array<string>,
    Image: Array<General_Interface>,
    Draft: boolean,
    PreOrder: boolean,
    CustomerRequest: boolean,
    Parent: number,
    copy: boolean,
    GiverUser: number,
    SectionId: Number,
    OrderId: Number,
    DscOrder: string,
    parentRefer: number,
    TariffFloor: number): Observable<Letter_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var Local_model = {
      id: model.id,
      cutomer_id: customer.id,
      customer_name: customer.name,
      customer_name_en: customer.name_en,
      customer_code : customer.code,
      customer_address_id: customerAddress.id,
      customer_address_address: customerAddress.address,
      customer_address_certificate: customerAddress.certificateAddress,
      customer_address_certificate_en: customerAddress.certificateAddress_en,
      giver_name: model.giver_name,
      draftTitle: model.draftTitle,
      giver_semat: model.giver_semat,
      subject_id: model.subject_id,
      peyvast: model.peyvast,
      takhfif: model.takhfif,
      arsh_afzoodeh: model.arsh_afzoodeh,
      sex: model.sex,
      draft: Draft,
      codePeygiri: model.codePeygiri,
      preOrder: PreOrder,
      customerRequest: CustomerRequest,
      parent: Parent,

      textletter_id: model.textletter_id,
      bazgashtBeNamehShomareh: model.bazgashtBeNamehShomareh,
      bazgashtBeNamehTarikh: null,
      pishPardakht: model.pishPardakht,
      khadamat: model.khadamat,

      delivery: model.delivery,
      dsc: model.dsc,

      Reciver_Customer_id: model.reciver_Customer_id,
      Reciver_Customer_Dsc: model.reciver_Customer_Dsc,
    }

    var DataEntityList_Image = []
    for (let item of Image) {
      DataEntityList_Image.push({
        src: item.title,
        show:item.del,
      })
    }

    var Local_Device: Array<any> = []
    var Local_Device_File: Array<any> = []
    var Index:number=0
    for (let item of Device) {
      Local_Device.push({
        id: item.id,
        letter_id: 0,
        ordder :Index,
        devicePersian_id: item.device_id,
        deviceName: item.device_name,
        location: item.location_id == 1,
        tedad: item.tedad,
        price_id: item.price_id,
        expiration_id: Number(item.expiration+""),
        deviceName_En: item.device_name_en,
        dsc: item.dsc,
        dscUser: item.dscUser,
        incRailModir: item.incRailModir,
        del: false,
      })

      if(item.file!=null)
      {
        for(let itemFile of item.file)
        {
          Local_Device_File.push({
            id:0,
            letter_device_id:Index,
            src:itemFile
          })
        }
      }

      Index=Index+1

    }

    var Local_Dsc: Array<any> = []
    for (let item of Dsc) {
      Local_Dsc.push({
        id: 0,
        letter_id: 0,
        dsc: item,
        del: false,
      })
    }

    var Local_MailMessage: Array<any> = []
    for (let item of MailMessage) {
      Local_MailMessage.push({
        id: 0,
        mailmessage_id: item.id
      })
    }


    var Local_MailMessage_Schedule: Array<any> = []
    for (let item of MailMessage_Schedule) {
      Local_MailMessage_Schedule.push({
        id: 0,
        mailmessage_id: item.id
      })
    }

    var Local_Schedules: Array<any> = []
    var Local_expert: Array<any> = []
    var Local_deviceBehfa: Array<any> = []
    var indexer: number = 0

    for (let item of Schedule) {
      Local_Schedules.push({
        id: item.id,
        letter_id: 0,
        status: item.status,
        dsc: item.dsc,
        comment: item.comment,
        persianDate: item.persianDate,
        startDate:item.startDate,
        endDate:item.endDate,
        del:item.del,
      })


      for (let detail of item.expert) {

        Local_expert.push({
          id:detail.id_temp,
          letterRequestCustomer_Schedules: indexer,
          expert_Calibration: detail.id,
          name: detail.name,
          familly: detail.familly,
          codemeli: detail.melicode + "",
          pedar: detail.name_Pedar,
          tarikh_Tavalod: detail.tarikh_Tavalod,
          mobile: detail.shomareh_Hamreh,
          selected : detail.seleted,
          del:detail.del
        })

      }



      for (let detail of item.deviceBehfa) {

        if (detail.del != true) {
          Local_deviceBehfa.push({
            id: detail.id_temp,
            letterRequestCustomer_Schedules: indexer,
            deviceBehfa_id: detail.id,
            code: detail.code,
            description: detail.description,
            manufacturer: detail.manufacturer + "",
            model: detail.model,
            codeBEHFA: detail.codeBEHFA,
            del: detail.del
          })
        }
     }

      indexer = indexer + 1
    }


    var body = {
      Token: '',
      bazgashtBeNamehTarikh: bazgashtBeNamehTarikh,
      model: Local_model,
      schedules: Local_Schedules,
      expert: Local_expert,
      deviceBehfa: Local_deviceBehfa,
      device: Local_Device,
      device_image: Local_Device_File,
      dsc: Local_Dsc,
      image: DataEntityList_Image,
      mailMessage: Local_MailMessage,
      mailMessage_Schedule: Local_MailMessage_Schedule,
      GiverUser: GiverUser,
      SectionId: SectionId,
      DscOrder: DscOrder,
      OrderId: OrderId,
      copy: copy,
      parentRefer: parentRefer,
      TariffFloor: TariffFloor,
      LetterId: 0,
    }

    return this.http.post(environment.BaseUrl + "Daro/Letterrequestcustomer/AddEdit", body, { headers }).pipe(
      map(data => {
        return data as Letter_Interface
      })
    )

  }

  AddEditSchduleForm(model: Letter_Interface,
    Schedule: Array<LetterRequestCustomer_Schedule_Interface>,
    MailMessage_Schedule: Array<General_Interface>,
    ForceSubmit:boolean): Observable<Letter_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var Local_model = {
      id: model.id,

      giver_name: model.giver_name,
      draftTitle: model.draftTitle,
      giver_semat: model.giver_semat,
      subject_id: model.subject_id,
      peyvast: model.peyvast,
      takhfif: model.takhfif,
      arsh_afzoodeh: model.arsh_afzoodeh,
      sex: model.sex,
      codePeygiri: model.codePeygiri,
      textletter_id: model.textletter_id,
      bazgashtBeNamehShomareh: model.bazgashtBeNamehShomareh,
      bazgashtBeNamehTarikh: null,
      pishPardakht: model.pishPardakht,

      delivery: model.delivery,
      dsc: model.dsc,

      Reciver_Customer_id: model.reciver_Customer_id,
      Reciver_Customer_Dsc: model.reciver_Customer_Dsc,
    }

    var DataEntityList_Image = []


    var Local_Device: Array<any> = []
    var Local_Device_File: Array<any> = []
    var Local_Dsc: Array<any> = []
    var Local_MailMessage: Array<any> = []


    var Local_Schedules: Array<any> = []
    var Local_expert: Array<any> = []
    var Local_deviceBehfa: Array<any> = []
    var indexer: number = 0

    var Local_MailMessage_Schedule: Array<any> = []
    for (let item of MailMessage_Schedule) {
      Local_MailMessage_Schedule.push({
        id: 0,
        mailmessage_id: item.id
      })
    }

    for (let item of Schedule) {
      Local_Schedules.push({
        id: item.id,
        letter_id: 0,
        status: item.status,
        dsc: item.dsc,
        comment: item.comment,
        persianDate: item.persianDate,
        startDate:item.startDate,
        endDate:item.endDate,
        del:item.del,
        showPrint:item.showPrint,
      })


      for (let detail of item.expert) {

        Local_expert.push({
          id:detail.id_temp,
          letterRequestCustomer_Schedules: indexer,
          expert_Calibration: detail.id,
          name: detail.name,
          familly: detail.familly,
          codemeli: detail.melicode + "",
          pedar: detail.name_Pedar,
          mobile: detail.shomareh_Hamreh,
          selected : detail.seleted,
          del:detail.del
        })

      }



      for (let detail of item.deviceBehfa) {

        Local_deviceBehfa.push({
          id:detail.id_temp,
          letterRequestCustomer_Schedules: indexer,
          deviceBehfa_id : detail.id,
          code: detail.code,
          description: detail.description,
          manufacturer: detail.manufacturer + "",
          model: detail.model,
          codeBEHFA: detail.codeBEHFA,
          del:detail.del
        })
     }

      indexer = indexer + 1
    }


    var body = {
      Token: '',
      bazgashtBeNamehTarikh: '',
      model: Local_model,
      schedules: Local_Schedules,
      expert: Local_expert,
      deviceBehfa: Local_deviceBehfa,
      device: Local_Device,
      device_image: Local_Device_File,
      dsc: Local_Dsc,
      image: DataEntityList_Image,
      mailMessage: Local_MailMessage,
      mailMessage_Schedule: Local_MailMessage_Schedule,
      GiverUser: 0,
      SectionId: 0,
      DscOrder: '',
      OrderId: 0,
      LetterId: 0,
      ForceSubmit:ForceSubmit,
    }



    return this.http.post(environment.BaseUrl + "Daro/Letterrequestcustomer/AddEditSchduleForm", body, { headers }).pipe(
      map(data => {
        return data as Letter_Interface
      })
    )

  }

  SubmitActionLetter(LetterId: number,
    GiverUser: number,
    SectionId: Number,
    OrderId: Number,
    DscOrder: string,
    parentRefer: number): Observable<Letter_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var TempLetterId=Number(LetterId)

    var body = {
      Token: '',
      LetterId:TempLetterId ,
      GiverUser: GiverUser,
      SectionId: SectionId,
      DscOrder: DscOrder,
      OrderId: OrderId,
      parentRefer: parentRefer,
    }


    return this.http.post(environment.BaseUrl + "Daro/Letterrequestcustomer/SubmitActionLetter", body, { headers }).pipe(
      map(data => {
        return data as Letter_Interface
      })
    )

  }

  PostLetterRequestCustomerDevice_Detail(id: Number,
    deviceCode: String,
    deviceSerial: String,
    gostareh: String,
    dsc: String): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {
      username: '',
      deviceCode: deviceCode,
      deviceSerial: deviceSerial,
      gostareh: gostareh,
      dsc: dsc,
      id: id,
    }


    return this.http.post(environment.BaseUrl + "Daro/Letterrequestcustomer/PostLetterRequestCustomerDevice_Detail", body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }


  SubmitNoteHistory(id: number,
    dsc: string): Observable<Letter_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {
      token: '',
      id: id,
      dsc: dsc,
    }


    return this.http.post(environment.BaseUrl + "Daro/Letterrequestcustomer/SubmitNoteHistory", body, { headers }).pipe(
      map(data => {
        return data as Letter_Interface
      })
    )

  }


  uploadFile(body) {

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/Letterrequestcustomer/Upload", body).pipe(
      map(data => {

        return data
      })
    )
  }


  ChangeStatus90(id: Number,
    status: number,
    dsc: string): Observable<Letter_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      token: '',
      status: status,
      dsc: dsc,
      id: id,
    }


    return this.http.post(environment.BaseUrl + "Daro/Letterrequestcustomer/ChangeStatus90", body, { headers }).pipe(
      map(data => {
        return data as Letter_Interface
      })
    )

  }

  GetHistory(
    id: number,): Observable<Array<LetterRequestCustomer_History_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/GetHistory1?id=" + id).pipe(
        map(data => {
          return data as Array<LetterRequestCustomer_History_Interface>
        })
      )
  }



  Getletterrole(
    id: number,): Observable<Array<Nav_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/Getletterrole?id=" + id).pipe(
        map(data => {
          return data as Array<Nav_Interface>
        })
      )
  }

  GetPeyvast1(
    id: number,): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/GetPeyvast?id=" + id).pipe(
        map(data => {
          return data as any
        })
      )
  }

  DeleteDevice(id:number): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/DeleteDevice?id=" + id).pipe(
      map(data => {
        return data as any
      })
    )
  }

  DeleteBazgashtDevice(id:number,dsc: String): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/DeleteBazgashtDevice?id=" + id
      + "&dsc=" + dsc).pipe(
      map(data => {
        return data as any
      })
    )
  }


  SendSmsLetter(id: number, order: number,Karshnash:String): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/SendSmsLetter?id=" + id
      + "&Karshnash=" + Karshnash
      + "&order=" + order).pipe(
        map(data => {
          return data as any
        })
      )
  }

  SendSmsLetter_PreOrder_NoMatch(id: number, order: number,Karshnash:String): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/SendSmsLetter_PreOrder_NoMatch?id=" + id
      + "&Karshnash=" + Karshnash
      + "&order=" + order).pipe(
        map(data => {
          return data as any
        })
      )
  }




  GetActivity(
    id: number,): Observable<Array<LetterRequestCustomer_Activity>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/GetActivity?id=" + id).pipe(
        map(data => {
          return data as Array<LetterRequestCustomer_Activity>
        })
      )
  }

  PostActivity(letter_id: Number,
    karshnas_masol_id: Number,
    link_type: Number,
    link_dsc: String,
    dsc: String,
    file: Array<String>): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {
      letter_id: Number(letter_id),
      karshnas_masol_id: karshnas_masol_id,
      link_type: link_type,
      link_dsc: link_dsc,
      dsc: dsc,
      file: file,
    }


    return this.http.post(environment.BaseUrl + "Daro/Letterrequestcustomer/PostActivity", body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }

  DeleteActivity(
    id: number,): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/DeleteActivity?id=" + id).pipe(
        map(data => {
          return data as any
        })
      )
  }

  GetActivityAvailableDevice(
    id: number,): Observable<Array<LetterRequestCustomer_Device_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/GetActivityAvailableDevice?id=" + id).pipe(
        map(data => {
          return data as Array<LetterRequestCustomer_Device_Interface>
        })
      )
  }
  AddAllActivityDevice(
    id: number,): Observable<Array<LetterRequestCustomer_Device_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/AddAllActivityDevice?letter_schedule_id=" + id).pipe(
        map(data => {
          return data as Array<LetterRequestCustomer_Device_Interface>
        })
      )
  }

  GetActivityDevice(
    id: number,): Observable<Array<LetterRequestCustomer_Device_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/GetActivityDevice?id=" + id).pipe(
        map(data => {
          return data as Array<LetterRequestCustomer_Device_Interface>
        })
      )
  }

  AddActivityDevice(
    letter_device_id: number,
    letter_schedule_id: number,): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/AddActivityDevice?letter_device_id=" + letter_device_id
      + "&letter_schedule_id=" + letter_schedule_id).pipe(
        map(data => {
          return data as any
        })
      )
  }

  RemoveActivityDevice(
    letter_device_id: number,
    letter_schedule_id: number): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/RemoveActivityDevice?letter_device_id=" + letter_device_id
      + "&letter_schedule_id=" + letter_schedule_id).pipe(
        map(data => {
          return data as any
        })
      )
  }

  SwichActivityDevice(
    id: number): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/SwichActivityDevice?id=" + id).pipe(
        map(data => {
          return data as any
        })
      )
  }

  SwichActivityDsc(
    id: number): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/SwichActivityDsc?id=" + id).pipe(
        map(data => {
          return data as any
        })
      )
  }

  SwichActivityVisible(
    id: number): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/SwichActivityVisible?id=" + id).pipe(
        map(data => {
          return data as any
        })
      )
  }

  SubmitDeviceMissionDsc(
    dsc: String,
    letter_device_id: number,
    letter_schedule_id: number): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/SubmitDeviceMissionDsc?dsc=" + dsc
      + "&letter_device_id=" + letter_device_id
      + "&letter_schedule_id=" + letter_schedule_id).pipe(
        map(data => {
          return data as any
        })
      )
  }

  PostActivityForm(karshnas_masol_id: number, address_id: number, id: number): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/PostActivityForm?karshnas_masol_id=" + karshnas_masol_id
      + "&address_id=" + address_id
      + "&id=" + id).pipe(
        map(data => {
          return data as any
        })
      )
  }

  GetActivityForm(id: number,): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/GetActivityForm?id=" + id).pipe(
        map(data => {
          return data as any
        })
      )
  }




  GetReview(
    id: number,): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/GetReview?id=" + id).pipe(
        map(data => {
          return data as any
        })
      )
  }

  PostReview(id: number, s1: String, s1_1: String, s1_2: String, s2: String, s3: String, s4: String, s5: String, s6: String, s7: String, s8: String, s9: String): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      s1:s1,
      s1_1:s1_1,
      s1_2:s1_2,
      s2:s2,
      s3:s3,
      s4:s4,
      s5:s5,
      s6:s6,
      s7:s7,
      s8:s8,
      s9:s9,
      letter_id:Number(id),
      create_username:''
    }

    return this.http.post(environment.BaseUrl + "Daro/Letterrequestcustomer/PostReview", body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }


  SubmitSchedulesRelative(letterRequestCustomer_Schedules_first: number,
    letterRequestCustomer_Schedules_second: number,): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/SubmitSchedulesRelative?letterRequestCustomer_Schedules_first=" + letterRequestCustomer_Schedules_first
      + "&letterRequestCustomer_Schedules_second=" + letterRequestCustomer_Schedules_second).pipe(
        map(data => {
          return data as any
        })
      )
  }

  RemoveSchedulesRelative(id: number,): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/RemoveSchedulesRelative?id=" + id).pipe(
        map(data => {
          return data as any
        })
      )
  }

  GetSchedulesRelative(id:number): Observable<Array<LetterRequestCustomer_Cancel>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/GetSchedulesRelative?id=" + id).pipe(
        map(data => {
          return data as Array<LetterRequestCustomer_Cancel>
        })
      )
  }


  GetFilePeyvastActivity(id:number): Observable<Array<General_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/GetFilePeyvastActivity?id=" + id).pipe(
        map(data => {
          return data as Array<General_Interface>
        })
      )
  }

  AddFilePeyvastActivity(file_id: number,
    letter_schedule_id: number): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/AddFilePeyvastActivity?file_id=" + file_id
      + "&letter_schedule_id=" + letter_schedule_id).pipe(
        map(data => {
          return data as any
        })
      )
  }

  RemoveFilePeyvastActivity(id: number): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/RemoveFilePeyvastActivity?id=" + id).pipe(
        map(data => {
          return data as any
        })
      )
  }

  Answer_CancelScheduleRequest(id: number,status: number, dsc: String): Observable<any> {

    return this.http.get(environment.BaseUrl + "Daro/Letterrequestcustomer/Answer_CancelScheduleRequest?id=" + id
      + "&status=" + status
      + "&dsc=" + dsc
      ).pipe(
      map(data => {
        return data as any
      })
    )

  }

  Confirm_CancelScheduleRequest(code: String, id: number): Observable<any> {

    return this.http.get(environment.BaseUrl + "Daro/Letterrequestcustomer/Confirm_CancelScheduleRequest?Code=" + code
      + "&id=" + id
      ).pipe(
      map(data => {
        return data as any
      })
    )

  }

  GetLetterRequestCustomerScheduleDeviceBehfa(device_id: number,
    group_id: number,
    sub_group_id: number,
    startDate: string,
    endDate:string): Observable<Array<LetterRequestCustomer_Schedule_BehfaDevice_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/GetLetterRequestCustomerScheduleDeviceBehfa?device_id=" + device_id
      + "&group_id=" + group_id
      + "&sub_group_id=" + sub_group_id
      + "&startDate=" + startDate
      + "&endDate=" + endDate).pipe(
        map(data => {
          return data as Array<LetterRequestCustomer_Schedule_BehfaDevice_Interface>
        })
      )
  }

  DeleteLetterHistoryRecord(id: number): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/DeleteLetterHistoryRecord?id=" + id).pipe(
      map(data => {
        return data as any
      })
    )
  }

  ChangeSchduleShowPrint(id: number): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/ChangeSchduleShowPrint?id=" + id).pipe(
      map(data => {
        return data as any
      })
    )
  }

  ChangeSchduleIsout(id: number): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/ChangeSchduleIsout?id=" + id).pipe(
      map(data => {
        return data as any
      })
    )
  }

  SetLetterRequestCustomerImageShow(id: number): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/SetLetterRequestCustomerImageShow?id=" + id).pipe(
      map(data => {
        return data as any
      })
    )
  }
  

  GetLetterRequestCustomerImage(id: number): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/GetLetterRequestCustomerImage?id=" + id).pipe(
      map(data => {
        return data as any
      })
    )
  }


  GetLetterRequestCustomerReport(
    StartDate: String,
    EndDate: String,
    LetterTypeId: number,
    SubjectId: String,
    SubmitPeriodDate: number,
    DeviceName: String,
    LetterNumber: String): Observable<Array<LetterRequestCustomer_List_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Letterrequestcustomer/GetLetterRequestCustomerReport?StartDate=" + StartDate
      + "&EndDate=" + EndDate
      + "&LetterTypeId=" + LetterTypeId
      + "&SubjectId=" + SubjectId
      + "&DeviceName=" + DeviceName
      + "&SubmitPeriodDate=" + SubmitPeriodDate
      + "&LetterNumber=" + LetterNumber
    ).pipe(
      map(data => {
        return data as Array<LetterRequestCustomer_List_Interface>
      })
    )
  }


}
